// Pages/Inventory/Adjustments/index.jsx
import React, { useEffect, useState } from "react";
import Header from "../../../../Componets/Header";
import Status from "../../../../Componets/Status";
import ActionButton from "../../../../Componets/Buttons/action";
import Table from "../../../../Componets/Table";
import { get_all_inventory_adjustments } from "../../../../Controllers/Inventory/Adjustment";
import toast from "react-hot-toast";
import tables from "../../../../Data/Tables/Inventory/Adjustment/tables";
import headers from "../../../../Data/Tables/Inventory/Adjustment/headers";
import Loadercomponent from "../../../../Componets/Loader";
import moment from "moment";

const InventoryAdjustmentsTable = () => {
    const [loader, setLoader] = useState(false);
    const [header, setHeader] = useState(headers);
    const [body, setBody] = useState();

    const [pagination, setPagination] = useState({
        currentPage: 1,
        totalCount: 0,
        totalPages: 0,
    });

    const paginationdata = (data) => {
        let headerdata = {};
        header?.components?.map((value) => {
            headerdata[value.name] = value.value;
        });

        fetchData({
            ...data,
            search: headerdata?.search,
            sort: headerdata?.sort,
            type: headerdata?.type,
            date: headerdata?.date,
            status: headerdata?.status,
        });
    };

    const formdata = (data) => {
        let page = data?.search ? pagination?.currentPage : 1;
        fetchData({
            ...data,
            currentPage: page,
            totalCount: pagination?.totalCount,
            totalPages: pagination?.totalPages,
        });
    };

    const actiondata = (data) => {
        let headerdata = {};
        headers?.components?.map((value) => {
            headerdata[value.name] = value.value;
        });

        fetchData({
            ...data,
            search: headerdata?.search,
            sort: headerdata?.sort,
            type: headerdata?.type,
            date: headerdata?.date,
            status: headerdata?.status,
            currentPage: pagination?.currentPage,
            totalCount: pagination?.totalCount,
            totalPages: pagination?.totalPages,
        });
    };

    const fetchData = async (tabledata) => {
        try {
            setLoader(true);

            const data = {
                search: tabledata?.search,
                sort: tabledata?.sort,
                type: tabledata?.type,
                date: tabledata?.date,
                status: tabledata?.status,
                page: tabledata?.currentPage,
            };

            const adjustments = await get_all_inventory_adjustments(data);

            if (adjustments?.status) {
                let rows = [];

                adjustments?.data?.data?.map((value) => {
                    rows?.push({
                        path: `/app/inventory/adjustment/view/${value?._id}`,
                        Date: moment?.(value?.date)?.format("DD-MM-YYYY"),
                        Batch: `#BATCH-${value?.inventory?.number}`,
                        Product: value?.inventory?.product?.name,
                        Type: (
                            <span className={`capitalize px-2 py-1 rounded text-xs font-medium
                ${value?.type === "damage" ? "bg-red-100 text-red-700" : ""}
                ${value?.type === "wastage" ? "bg-orange-100 text-orange-700" : ""}
                ${value?.type === "expired" ? "bg-yellow-100 text-yellow-700" : ""}
                ${value?.type === "return" ? "bg-green-100 text-green-700" : ""}
              `}>
                                {value?.type}
                            </span>
                        ),
                        Quantity: value?.quantity,
                        Before: parseFloat(value?.stock_before)?.toFixed(3),
                        After: parseFloat(value?.stock_after)?.toFixed(3),
                        Reason: value?.reason,
                        Status: <Status status={value?.status} />,
                        Action: (
                            <ActionButton
                                edit={`/app/inventory/adjustment/edit/${value?._id}`}
                                id={value?._id}
                                api="delete-inventory-adjustment"
                                actiondata={actiondata}
                                headers={header}
                            />
                        ),
                    });
                });

                setBody(rows);
                setPagination({
                    currentPage: adjustments?.data?.currentPage,
                    totalCount: adjustments?.data?.totalCount,
                    totalPages: adjustments?.data?.totalPages,
                });
                setLoader(false);
            } else {
                setLoader(false);
                if (adjustments?.status_code == 403) {
                    window.location.href = "/unauthorized";
                } else {
                    toast?.error(adjustments?.message);
                }
            }
        } catch (errors) {
            toast?.error(errors?.message);
        }
    };

    const headerReset = () => {
        let componentData = [];
        headers?.components?.map((value) => {
            componentData?.push({ ...value, value: null });
        });
        setHeader({ ...headers, components: componentData });
    };

    useEffect(() => {
        fetchData();
        headerReset();
    }, []);

    return (
        <Header headers={header} setHeaders={setHeader} formdata={formdata}>
            <Loadercomponent loader={loader}>
                <Table
                    head={tables}
                    body={body}
                    pagination={pagination}
                    paginationdata={paginationdata}
                />
            </Loadercomponent>
        </Header>
    );
};

export default InventoryAdjustmentsTable;